<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/i6vBxG/tc-custom/9781617458026.jpg?1737667685447" alt="This image is the cover for the book 52 Playful Pot Holders to Applique"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">52 Playful Pot Holders to Applique
      </h1>
      <p class="bookDescription body article font2">
        <b>The bestselling author of <i>Festive Fall Quilts</i> shares 52 appliqué pot holders to cheer up your cooking and to give as gifts all year long.</b><br/><br/>If you can’t stand the heat, get out the pot holders! Bestselling author Kim Schaefer shares fifty-two darling hot pad designs to appliqué, one for every week of the year. Pick one of three fully bound shapes—square, round, and oval—and create your own festive kitchen set. With more than four dozen seasonal, holiday, and kitchen-themed motifs, each with full-size appliqué patterns, you’ll want to make these pretty and useful gifts for everyone you know; they’re perfect for housewarmings, weddings, bridal showers, and more!<br/><br/><b>Includes links to printable, full-size patterns</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kim Schaefer
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing, Inc.,
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?36d0db26